<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-form  v-model="valid"
             lazy-validation
             ref="form"
             id="edit-card-form">
    <v-layout
      justify-center
      wrap
    >

      <v-flex
        xs12
        md8
      >

        <material-card
          color="green"
          title="اضافة عينة جديدة"
          text="يرجى ادخال معلومات العينة المراد اضافتها الى قيد المراجع"
        >

            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="fullname"
                    readonly
                    disabled
                    label="إسم الطفل الرباعي"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="barcode"
                    :rules="[rules.required]"
                    class="purple-input"
                    label="رقم العينة"
                  />
                </v-flex>

                <v-flex
                  xs12
                  md6
                >
                  <v-autocomplete
                          :items="healthdeps"
                          v-model="healthdep"
                          label="دائرة الصحة"
                          class="purple-input"
                          :rules="[rules.required]"></v-autocomplete>
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                  v-model="sector"
                    label="القطاع"
                  :rules="[rules.required]"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    v-model="healthcenter"
                    label="المركز الصحي"
                    :rules="[rules.required]"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md4>
                  <v-text-field
                  v-model="takenby"
                    label="اسم القائم بأخذ العينة"
                    class="purple-input"/>
                </v-flex>



                <v-flex
                        xs12
                        md4>

                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-text-field
                              v-on="on"
                              readonly
                              v-model="takendate"
                              :rules="[rules.required]"
                              class="purple-input"
                              label="تاريخ اخذ العينة"/>

                    </template>
                    <v-date-picker :max="max_date" :min="min_date"  v-model="takendate" />
                  </v-menu>
                </v-flex>


                <v-flex
                    xs12
                    md12>
                  <v-autocomplete
                      :items="this.$store.state.checktypes"
                      v-model="status"
                      label="نوع الفحص"
                      class="purple-input"
                  ></v-autocomplete>
                </v-flex>


                  <v-flex
                          xs12
                          md4>
                      <v-checkbox
                              v-model="duplicate"
                              label="عينة مكررة ؟"
                              color="success"
                              value="1"
                      />
                  </v-flex>


                <v-flex
                    xs12
                    md4>
                  <v-checkbox
                      v-model="rejected"
                      label="عينة مرفوضة ؟"
                      color="success"
                      value="1"
                  />
                </v-flex>



                  <v-flex
                        xs12
                        md4>
                  <v-text-field
                          v-model="duplicatereason"
                          class="purple-input"
                          label="سبب رفض / تكرار العينة"/>
                </v-flex>

              </v-layout>
            </v-container>

        </material-card>
      </v-flex>

      <v-flex
              xs12
              md4
      >

        <material-card
                color="orange"
                title="نتائج فحص Galactosemia"
                text="يرجى ادخال بيانات الفحص المستخرجة من الجهاز"
        >

          <v-container py-0>
            <v-layout wrap>
              <v-flex
                      xs12
                      md12
              >
                <v-text-field
                        v-model="gal.sttg"
                        prefix="mg/dL"
                        label="Screening Test - t. Glactose"
                />
                <v-text-field
                        v-model="gal.cttg"
                        prefix="mg/dL"
                        label="Confirmation - t.Glactose"
                />
                <v-text-field
                        v-model="gal.ctgalt"
                        prefix="U/g Hb"
                        label="Confirmation GALT"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </material-card>

        <material-card
                color="purple"
                title="نتائج فحص PKU"
                text="يرجى ادخال بيانات الفحص المستخرجة من الجهاز"
        >

          <v-container py-0>
            <v-layout wrap>
              <v-flex
                      xs12
                      md12
              >
                <v-text-field
                        v-model="pku.stph"
                        prefix="mg/dL"
                        label="Screening test - Phenylalanine"
                />
                <v-text-field
                        v-model="pku.ctph"
                        prefix="μM"
                        label="Confirmation - Phenylalanine"
                />
                <v-text-field
                        v-model="pku.ctty"
                        prefix="μM"
                        label="Confirmation - Tyrosine"
                />
                <v-text-field
                        v-model="pku.ctpr"
                        label="Confirmation - PiT Ratio"
                />

              </v-flex>
            </v-layout>
          </v-container>
        </material-card>

        <material-card
                color="blue"
                title="نتائج فحص CHT"
                text="يرجى ادخال بيانات الفحص المستخرجة من الجهاز"
        >

          <v-container py-0>
            <v-layout wrap>
              <v-flex
                      xs12
                      md12
              >
                <v-text-field
                        v-model="cht.sttsh"
                        prefix="mg/dL"
                        label="Screening test - TSH"
                />
                <v-text-field
                        v-model="cht.cttsh"
                        prefix="μU/ml"
                        label="Confirmation - TSH"
                />
                <v-text-field
                        v-model="cht.ctfty"
                        prefix="pmol/L"
                        label="Confirmation FTY"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </material-card>


      </v-flex>


          <v-flex
                  md12
                  xs12
                  text-xs-right
                    >
                    <v-btn
                        @click="validateFunc"
                        :disabled="!valid"
                        class="mx-0 font-weight-bold"
                        color="success"
                    >
             إضافة العينة
            </v-btn>
          </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>

import {__GET_AS_LIST,__HTTP,FormHeader} from '@/utils/utils'

  export default {
    computed: {
      fullname() {
        return this.$route.query.pname
      }
    },
    data: () => ({
      max_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      min_date: '2020-01-01',
      valid: true,
      // Validation Rules
      rules: {
        required: value => !!value || 'هذا الحقل مطلوب',
        counter: value => value.length <= 40 || 'الحد الأقصى هو 40 حرف',
        phonecounter: value =>  {
          const pattern = /^0?7[0-9]{9,9}$/;

          return pattern.test(value) || 'رقم الهاتف غير صحيح'
        },
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'البريد الالكتروني غير صحيح'
        },
        strength: value => {
          const pattern = /^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})/
          return pattern.test(value) || 'يجب ان تكون كلمة السر مكونة حروف كبيرة، حروف صغيرة,ارقام , علامات خاصةو لاتقل عن ٦ ارقام او حروف'
        },
      },
      gal: {
        sttg: '',
        cttg: '',
        ctgalt: ''
      },
      pku: {
        stph: '',
        ctph: '',
        ctpr: '',
        ctty: ''
      },
      cht: {
        sttsh: '',
        cttsh: '',
        ctfty: ''
      },
      picker: new Date().toISOString().substr(0, 10),
      date: new Date().toISOString().substr(0, 10),
      barcode: '',
      healthcenter: '',
      sector: '',
      status: '',
      healthdep: '',
      takenby: '',
      takendate: '',
      duplicatereason: '',
      duplicate: '',
      rejected: '',
      id: null,
      healthdeps:[]
    }),
    created() {
      this.getHealthDep()
    },
    methods: {
      validateFunc() {
        //console.log("btnClicked")
        if (this.$refs.form.validate()) {
          this.submitForm()
        }
      },

      getHealthDep() {
        __GET_AS_LIST("healthdep",{},(res) => {
          res.map((i) => {
            // console.log("xcxcx",i);
            this.healthdeps.push({text: i.title, value:i.id});
          });
        });

      },
      submitForm() {
        //console.log(this.healthdep);
        __HTTP("?do=newcard",
            {
                barcode: this.barcode,
                healthcenter: this.healthcenter,
                healthsector: this.sector,
                healthdep: this.healthdep,
                takenby: this.takenby,
                takendate: this.takendate,
                status: this.status,
                duplicatereason: this.duplicatereason,
                duplicate: this.duplicate ? 1 : 0,
                rejected: this.rejected ? 1 : 0,
                patientid: this.$route.query.pid,
                gal: this.gal,
                pku: this.pku,
                cht: this.cht
            },
            FormHeader,
            (res) => {
               if (res.auth === true) {
                  this.$router.push({path: '/list-patients'})
                }
          });
      }
    }
  }
</script>
